import { TweenLite, TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';
import ScrollMagicController from '../class/ScrollMagicController';
import { Expo } from 'gsap/gsap-core';

class Expertises {
	constructor() {
		this.sections = document.querySelectorAll('.expertises');
		this.animate();
	}

	animate() {
		this.sections.forEach((section) => {
			const blocks = section.querySelectorAll('.expertises__expertise');
			blocks.forEach((block) => {
				const blockAnimation = TweenMax.fromTo(block, 0.4, { y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, 0.2);
				const timeline = new TimelineLite();
				timeline.add(blockAnimation);

				new ScrollMagic.Scene({
					triggerHook: 0.85,
					triggerElement: block,
					offset: -50,
					reverse: false,
				})
					.setTween(timeline)
					.addTo(ScrollMagicController.controller);
			});
		});
	}
}

export default Expertises;
